<template>
  <BaseModal
        :id="'validations'"
        :title="`Validations`"
        :size="'lg'"
        :message="message"
        @close="close($event)"
    >

        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb_local"/>
        </template>

        <template v-slot:content> 
            <div class="w-100 table-responsive defaultproject__table overflow-y--2">
                <table class="table">
                    <thead>
                        <tr>
                            <th  scope="col" v-html="'#'"/>
                            <th v-for="(item, i) in validation_table_headers" :key="i" scope="col" v-html="item.text"/>
                        </tr>
                    </thead>
                    <tbody>
                        <template>
                                <tr v-for="(item, i) in  validate_data" :key="i" scope="col">
                                <td v-html="`${(i+1)}`"/>
                                    <td v-for="(header, j) in validation_table_headers" :key="j">
                                        <a v-html="item[header.value]"/>
                                    </td>
                                </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal            from    '@/components/BaseModal'

export default {
    name: 'ValidationsModal',

    props: [
        'breadcrumb',
        'validation_table_headers',
        'validate_data',
        'message'
    ],

    components: {
        BaseModal,
        Breadcrumb,
    },

    data() {
        return {
            breadcrumb_local: [...this.breadcrumb],
        };
    },

    methods: {
       close(event) {
           this.$emit('close', event)
       }
    },

    computed: {

    },

    mounted(){
        this.breadcrumb_local[this.breadcrumb.length - 1].arrow =  "<span class='slash'>/</span>"
        this.breadcrumb_local.push({
            name: 'Validation Modal',
            arrow: "",
        })
    }
}
</script>